const CreditsData = [
  {
    key: 1,
    id: `0127`,
    client: `Jacobi-Windler`,
    amount: "$2000",
    date: "15-05-2023",
    remaining: "$1000",
    status: "Paid",
  },
  {
    key: 2,
    id: `0127`,
    client: `Jacobi-Windler`,
    amount: "$2000",
    date: "15-05-2023",
    remaining: "$1000",
    status: "Sent",
  },
  {
    key: 3,
    id: `0127`,
    client: `Jacobi-Windler`,
    amount: "$2000",
    date: "15-05-2023",
    status: "Draft",
    remaining: "$1000",
  },
  {
    key: 4,
    id: `0127`,
    client: `Jacobi-Windler`,
    amount: "$2000",
    date: "15-05-2023",
    status: "Paid",
    remaining: "$1000",
  },
  {
    key: 5,
    id: `0127`,
    client: `Jacobi-Windler`,
    amount: "$2000",
    date: "15-05-2023",
    status: "Sent",
    remaining: "$1000",
  },
  {
    key: 6,
    id: `0127`,
    client: `Jacobi-Windler`,
    amount: "$2000",
    date: "15-05-2023",
    status: "Draft",
    remaining: "$1000",
  },
  {
    key: 7,
    id: `0127`,
    client: `Jacobi-Windler`,
    amount: "$2000",
    date: "15-05-2023",
    status: "Paid",
    remaining: "$1000",
  },
  {
    key: 8,
    id: `0127`,
    client: `Jacobi-Windler`,
    amount: "$2000",
    date: "15-05-2023",
    status: "Sent",
    remaining: "$1000",
  },
  {
    key: 9,
    id: `0127`,
    client: `Jacobi-Windler`,
    amount: "$2000",
    date: "15-05-2023",
    status: "Draft",
    remaining: "$1000",
  },
  {
    key: 10,
    id: `0127`,
    client: `Jacobi-Windler`,
    amount: "$2000",
    date: "15-05-2023",
    status: "Paid",
    remaining: "$1000",
  },
  {
    key: 11,
    id: `0127`,
    client: `Jacobi-Windler`,
    amount: "$2000",
    date: "15-05-2023",
    status: "Sent",
    remaining: "$1000",
  },
  {
    key: 12,
    id: `0127`,
    client: `Jacobi-Windler`,
    amount: "$2000",
    date: "15-05-2023",
    status: "Draft",
    remaining: "$1000",
  },
  {
    key: 13,
    id: `0127`,
    client: `Jacobi-Windler`,
    amount: "$2000",
    date: "15-05-2023",
    status: "Paid",
    remaining: "$1000",
  },
  {
    key: 14,
    id: `0127`,
    client: `Jacobi-Windler`,
    amount: "$2000",
    date: "15-05-2023",
    status: "Sent",
    remaining: "$1000",
  },
  {
    key: 15,
    id: `0127`,
    client: `Jacobi-Windler`,
    amount: "$2000",
    date: "15-05-2023",
    status: "Draft",
    remaining: "$1000",
  },
  {
    key: 16,
    id: `0127`,
    client: `Jacobi-Windler`,
    amount: "$2000",
    date: "15-05-2023",
    status: "Paid",
    remaining: "$1000",
  },
  {
    key: 17,
    id: `0127`,
    client: `Jacobi-Windler`,
    amount: "$2000",
    date: "15-05-2023",
    status: "Sent",
    remaining: "$1000",
  },
  {
    key: 18,
    id: `0127`,
    client: `Jacobi-Windler`,
    amount: "$2000",
    date: "15-05-2023",
    status: "Draft",
    remaining: "$1000",
  },
  {
    key: 19,
    id: `0127`,
    client: `Jacobi-Windler`,
    amount: "$2000",
    date: "15-05-2023",
    status: "Paid",
    remaining: "$1000",
  },
  {
    key: 20,
    id: `0127`,
    client: `Jacobi-Windler`,
    amount: "$2000",
    date: "15-05-2023",
    status: "Sent",
    remaining: "$1000",
  },
];

const CreditsMobData = [];

export { CreditsData, CreditsMobData };
